import { AUTH_COOKIE_KEY } from 'shared/constants/auth';

export default (cookies: { [key: string]: string }) =>
  AUTH_COOKIE_KEY.some(key => cookies[key]);
